import { Component } from '@angular/core';

@Component({
  selector: 'app-logout',
  imports: [],
  template: `
    <p>
      logout works!
    </p>
  `,
  styles: ``
})
export class Logout {

}
